<template>
  <div v-if="notice" class="check-notice" role="status">
    <h3>{{ notice.title }}</h3>
    <p>{{ notice.text }}</p>
    <ul v-if="warnings.length">
      <li v-for="(warning, index) in warnings" :key="index">{{ warning.text }}</li>
    </ul>
  </div>
</template>

<script>
import { ingredientCheckNotice, ingredientCheckWarnings } from '../utils/ingredientCheckResult';

export default {
  props: { result: { type: Object, required: true } },
  computed: {
    notice() { return ingredientCheckNotice(this.result); },
    warnings() {
      return ingredientCheckWarnings(this.result);
    },
  },
};
</script>

<style scoped>
.check-notice {
  margin: 20px 0;
  padding: 20px;
  color: #704b0b;
  background: #fff8e6;
  border: 1px solid #d9ae50;
  border-radius: 10px;
}
.check-notice h3 { margin: 0 0 8px; color: inherit; font-size: 18px; }
.check-notice p { margin: 0; }
.check-notice ul { margin-bottom: 0; }
</style>
